module.exports = __webpack_public_path__ + "img/67.68fd993a.jpg";